export const getLogoSize = (
	currentSize: number,
	maxSize: number,
	minSize: number,
	previousScrollY: number,
	currentScrollY: number,
) => {
	const scale = Math.ceil(currentScrollY / 20);

	const scrollDirection = currentScrollY > previousScrollY ? "down" : "up";
	if (currentSize <= minSize && scrollDirection === "down") {
		return minSize;
	}
	if (currentSize >= maxSize && scrollDirection === "up") {
		return maxSize;
	}

	// The user has scrolled down
	if (currentScrollY > previousScrollY + 1) {
		const nextSize = currentSize - scale;
		return nextSize >= minSize ? nextSize : minSize;
	}
	if (currentScrollY < previousScrollY - 1) {
		const nextSize = currentSize + scale;
		return nextSize <= maxSize ? nextSize : maxSize;
	}
	return currentSize;
};
